import { render, staticRenderFns } from "./MoleculeSave.vue?vue&type=template&id=508a1a48"
import script from "./MoleculeSave.vue?vue&type=script&lang=ts"
export * from "./MoleculeSave.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports